export default {
  state : {
    currentManager     : null,
    currentSurveyStart : null,
    // currentMenu        : `manager`,
  },
  mutations : {
    NAV_SET_CURRENT_MANAGER (state, manager) {
      state.currentManager = manager;
    },
    NAV_SET_CURRENT_SURVEYSTART (state, surveyStart) {
      state.currentSurveyStart = surveyStart;
    },
    NAV_SET_CURRENT_MENU (state, menu) {
      state.currentMenu = menu;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/navigation.js